import { ProfilePhoto } from "./profile-photo";

export interface IUser
{
    id: number,
    externalId: string;
    active: boolean,
    fullName: string,
    firstName: string,
    lastName: string,
    roles: string[],
    emailAddresses: string[],
    profilePhoto?: ProfilePhoto
    hemiPhoneNumber?: string
}

export class User implements IUser
{
    constructor
    (
        public id: number,
        public externalId: string,
        public firstName: string,
        public lastName: string,
        public roles: string[],
        public active: boolean,
        public fullName:string,
        public emailAddresses:string[],
        public profilePhoto?: ProfilePhoto,
        public hemiPhoneNumber?: string
    )
    {

    }
}

export class UserHeader implements IUser
{
    constructor
    (
        public id: number,
        public externalId: string,
        public active: boolean,
        public fullName: string,
        public firstName: string,
        public lastName: string,
        public roles: string[],
        public emailAddresses: string[],
        public profilePhoto?: ProfilePhoto,
        public hemiPhoneNumber?: string
    )
    {}

    static fromUser(user: User): UserHeader {
        return new UserHeader(
            user.id,
            user.externalId,
            user.active,
            user.fullName,
            user.firstName,
            user.lastName,
            user.roles,
            user.emailAddresses,
            user.profilePhoto,
            user.hemiPhoneNumber
        );
    }
}

export class UserInsert
{
    constructor
    (
        user: IUser
    )
    {
        this.externalId = user.externalId;
        this.active = user.active;
        this.firstName = user.firstName;
        this.lastName = user.lastName;
    }
    externalId: string
    active: Boolean;
    firstName: string;
    lastName: string;
}

export class UserUpdate
{
    constructor
    (
        public id: number
    )
    {

    }
    externalId?: string;
    active?: boolean;
    firstName?: string;
    lastName?: string;
    hemiPhoneNumber?: string;
}


export class UserEncounterCount
{
    constructor
    (
        public userId: number,
        public count: number
    )
    {}
}